<!-- Full calendar testing
<section class="title-bar content-padding first-item">
    <div class="wrapper">
      <h2 class="left">Test</h2>
      <br class="clear">
    </div>
</section>
<section id="schedaConsegna" class="content-padding">
    <div class="narrow-wrapper">
        <full-calendar 
            [options]="calendarOptions"
        ></full-calendar>
    </div>
</section>
Full calendar testing-->

<!-- Digital signature testing -->

<section class="main-content wrapper content-padding">
    <div class="content-panel">
        <div class="tabs">
            <label class="tab">
                <a class="tab-link active-tab" routerLink="/test">
                SIGNATURE DEMO
                </a>
            </label>
        </div>

        <div class="signature-wrapper">
            <h3 class="signature-title">Please sign below</h3>
            <div class="signature-card">
                <signature-pad
                [options]="signaturePadOptions"
                (onEnd)="drawComplete()">
                </signature-pad>

                <div class="signature-actions">
                <button class="btn clear-btn" (click)="clear()">Clear</button>
                <button class="btn save-btn" (click)="save()">Save</button>
                </div>
            </div>
        </div>
    </div>
</section>

